<template>
  <div id="app" class="app login">
    <div class="wrapper background-1-60" style="background: #64ccdc;">
      <Authorization-header v-if="!getIsLoggedIn" />
      <app-header v-if="getIsLoggedIn" />
      <main class="main">
        <div class="center template-404">
          <div class="main-title-404"><span class="group-404"><span>4</span><span></span><span>4</span></span>Page not found</div>
          <div class="main-404-label">
            <h1 class="color-2-100">This error is usually triggered by mistyping the page URL, but may also appear when a page was moved or the user doesn't have sufficient permissions to see it.</h1>
            <p class="color-2-100" v-if="getIsLoggedIn">Use the search box above or go to the homepage and start browsing our content from there. If you believe you found a bug in our system or you need any help, please email us at <a href="mailto:support.team@clearassured.co.uk">support.team@clearassured.co.uk</a></p>
            <a href="/" class="go-to-homepage color-2-100 background-1-30">Go to Homepage</a>
          </div>
        </div>
      </main>
      <div class="push"></div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import AuthorizationHeader from '@/components/main/common/AuthorizationHeader'
import AppFooter from '@/components/main/common/AppFooter'
import AppHeader from '@/components/common/AppHeader'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'error',
  data () {
    return {
      msg: 'Sorry, The Page is not exists'
    }
  },
  components: {
    AuthorizationHeader,
    AppFooter,
    AppHeader
  },
  computed: {
    ...mapGetters([
      'selectedHightCont',
      'getIsLoggedIn',
      'whiteYelWhite'
    ]),
    wrapperStyle () {
      let color
      switch (this.selectedHightCont) {
        case 0:
          color = '#000'
          break
        case 1:
          color = '#FFFA1A'
          break
        case 2:
          color = '#000'
          break
      }
      let style = {
        backgroundColor: this.bgColorSpOp,
        color
      }
      if (this.selectedHightCont === 1) {
        style.backgroundImage = 'none'
        style.backgroundColor = '#000'
      }
      return style
    }
  },
  methods: {
    ...mapActions([
      'setFontSizeActive',
      'setColorPaletteActive'
    ])
  },
  mounted () {
    this.setFontSizeActive()
    this.setColorPaletteActive()
  }
}
</script>

<style src="@/assets/scss/main/loginForAllPage.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// Error.vue?2fd04313